<div class="row footer-logo">
    <div class="col-md-6 col-12 logo-facility">
        @if (!!customLogoName) {
            <app-image-by-facility [src]="customLogoName" [height]="height" [width]="width" [isFullPath]="isFullPath" />
        } @else {
            <app-facility-logo
                class="logo"
                [mode]="themeType.dark"
                [height]="height"
                [width]="width"
                [context]="sectionLogo.footer"
            />
        }
    </div>
    <div class="col-md-6 col-12 logo-cargo-sprint">
        <img ngSrc="assets/img/powered-by-grey.webp" width="128" height="32" alt="powered-by" loading="lazy" />
    </div>
</div>
